import { CheckCircle2, XCircle, HelpCircle } from "lucide-react";

export const StatusBadge = ({ etat, libelle, size = "sm", testId }) => {
  const label = libelle || (etat === "A" ? "Actif" : etat === "C" ? "Cessé" : "Statut inconnu");
  const isActive = etat === "A";
  const isClosed = etat === "C";

  const styles = isActive
    ? "bg-[hsl(var(--ok))]/10 text-[hsl(var(--ok))] border-[hsl(var(--ok))]/30"
    : isClosed
    ? "bg-[hsl(var(--closed))]/10 text-[hsl(var(--closed))] border-[hsl(var(--closed))]/30"
    : "bg-muted text-[hsl(var(--fg-muted))] border-border";

  const Icon = isActive ? CheckCircle2 : isClosed ? XCircle : HelpCircle;

  return (
    <span
      data-testid={testId || "status-badge"}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 font-medium ${styles} ${
        size === "lg" ? "text-sm" : "text-xs"
      }`}
    >
      <Icon className={size === "lg" ? "h-4 w-4" : "h-3.5 w-3.5"} />
      {label}
    </span>
  );
};

export default StatusBadge;
